import {
  ADD_CART_ITEM,
  REMOVE_CART_ITEM,
  SET_CART_ITEMS,
  UPDATE_CART_ITEM,
} from "./types";

export const setCartItems = (data) => ({
  type: SET_CART_ITEMS,
  data: data,
});

export const addCartItem = (data) => ({
  type: ADD_CART_ITEM,
  data: data,
});

export const updateCartItem = (data) => ({
  type: UPDATE_CART_ITEM,
  data: data,
});

export const removeCartItem = (data) => ({
  type: REMOVE_CART_ITEM,
  data: data,
});
